const { getOffsetTop } = window.BAO.Utils

class Byline extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.isTicking = false

    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.setHeight()
    this.setParallax()
    this.updateEl()

    this.setAttribute('active', '')
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, {
      passive: true,
    })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.scaleMedia()
  }

  setHeight () {
    this.style.setProperty(
      '--Height',
      `${this.els.media.element.offsetHeight}px`,
    )
  }

  setParallax () {
    if (!this.hasAttribute('data-parallax')) return

    this.classList.add(this.dataset.fixedClass)
  }

  scaleMedia () {
    if (!this.hasAttribute('data-scale-effect')) return

    if (
      (window.BAO.MediaBreakpoints.isXsViewport &&
        this.dataset.mobileScale === 0) ||
      (window.BAO.MediaBreakpoints.isSm && this.dataset.desktopScale === 0)
    ) {
      return
    }

    const maxScale = window.BAO.MediaBreakpoints.isXsViewport
      ? this.dataset.mobileScale
      : this.dataset.desktopScale

    const imageStartsParallaxing = getOffsetTop(this) - window.innerHeight
    const imageEndsParallaxing = getOffsetTop(this)
    const totalScrollAmount = imageEndsParallaxing - imageStartsParallaxing

    if (this.lastKnownY < imageStartsParallaxing) {
      this.els.media.element.style.cssText = `--scale: ${maxScale}`

      return
    }

    if (this.lastKnownY > imageEndsParallaxing) {
      this.els.media.element.style.cssText = `--scale: 1`

      return
    }

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - imageStartsParallaxing) / totalScrollAmount
    const scaleAmount =
      maxScale - (maxScale - 1) * scrollYAsAPercentageOfJourney

    this.els.media.element.style.cssText = `--scale: ${scaleAmount}`
  }
}

if (!customElements.get('byline-section')) {
  customElements.define('byline-section', Byline)
}
